import React, { useState, useEffect, useRef, useCallback } from "react";
import "./DayHighStrategy.css";

// const DayHighStrategy = ({ symbol, live, quoteHigh, vwap }) => {
//   const [entries, setEntries] = useState([]);
//   const [lockedHigh, setLockedHigh] = useState(null);
//   const [morningAvgVolume, setMorningAvgVolume] = useState(null);
//   const [touchCount, setTouchCount] = useState(0);
//   const [status, setStatus] = useState("WAITING");
//   const [stopLoss, setStopLoss] = useState(null);
//   const [target1, setTarget1] = useState(null);
//   const [activeSignal, setActiveSignal] = useState(null);

//   const highTrackRef = useRef(null);
//   const volumeSamplesRef = useRef([]);
//   const signalFiredRef = useRef(new Set());
//   const pullbackAfterFirstRef = useRef(false);

//   const getIST = useCallback(() => {
//     const now = new Date();
//     const ist = new Date(
//       now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
//     );
//     return {
//       totalMins: ist.getHours() * 60 + ist.getMinutes(),
//       timeStr: ist.toLocaleTimeString("en-IN", {
//         timeZone: "Asia/Kolkata",
//         hour: "2-digit",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       }),
//     };
//   }, []);

//   const getPhase = useCallback((totalMins) => {
//     if (totalMins < 630) return "PRE_MARKET";
//     if (totalMins >= 630 && totalMins < 720) return "BUILDING";
//     if (totalMins === 720) return "LOCK";
//     if (totalMins > 720 && totalMins < 750) return "FIRST_WATCH";
//     if (totalMins >= 750 && totalMins < 870) return "SELL_ZONE";
//     if (totalMins >= 870 && totalMins < 930) return "AVOID";
//     return "CLOSED";
//   }, []);

//   const addEntry = useCallback(
//     (entry) => {
//       const { timeStr } = getIST();
//       setEntries((prev) =>
//         [{ id: Date.now(), time: timeStr, ...entry }, ...prev].slice(0, 100),
//       );
//     },
//     [getIST],
//   );

//   // Phase 1: Build High + Track Volume
//   useEffect(() => {
//     if (!live?.ltp) return;
//     const { totalMins } = getIST();
//     const phase = getPhase(totalMins);

//     if (phase === "BUILDING") {
//       const currentHigh = live.high || live.ltp;
//       if (!highTrackRef.current || currentHigh > highTrackRef.current) {
//         highTrackRef.current = currentHigh;
//       }
//       if (live.volume) volumeSamplesRef.current.push(live.volume);
//       setStatus("BUILDING");
//     }

//     if (phase === "LOCK" && !lockedHigh) {
//       const finalHigh = highTrackRef.current || live.high || quoteHigh;
//       const samples = volumeSamplesRef.current;
//       const avgVol =
//         samples.length > 0
//           ? Math.round(samples.reduce((a, b) => a + b, 0) / samples.length)
//           : null;
//       const sl = Number((finalHigh * 1.003).toFixed(2));

//       setLockedHigh(finalHigh);
//       setMorningAvgVolume(avgVol);
//       setStopLoss(sl);
//       setTarget1(vwap || null);
//       setStatus("WATCHING");

//       addEntry({
//         type: "LOCK",
//         message: `Day High locked. Morning avg vol: ${avgVol?.toLocaleString() || "—"}`,
//         price: live.ltp,
//         dayHigh: finalHigh,
//         score: null,
//       });
//     }
//   }, [live?.ltp, live?.high, live?.volume, lockedHigh, quoteHigh, vwap]);

//   // Phase 2: Monitor Retests
//   useEffect(() => {
//     if (!lockedHigh || !live?.ltp) return;
//     const { totalMins } = getIST();
//     const phase = getPhase(totalMins);

//     if (phase !== "FIRST_WATCH" && phase !== "SELL_ZONE") return;

//     const ltp = live.ltp;
//     const threshold = lockedHigh * 0.998;

//     if (touchCount === 1 && ltp < lockedHigh * 0.995) {
//       pullbackAfterFirstRef.current = true;
//     }

//     if (ltp < threshold) return;

//     const blockKey = `${Math.floor(totalMins / 3)}`;
//     if (signalFiredRef.current.has(blockKey)) return;
//     signalFiredRef.current.add(blockKey);

//     const newTouchCount = touchCount + 1;
//     setTouchCount(newTouchCount);

//     let score = 0;
//     const conditions = [];

//     score += 25;
//     conditions.push({ name: "Day High Locked", met: true, points: 25 });

//     const isSecondTouch = newTouchCount >= 2 && pullbackAfterFirstRef.current;
//     if (isSecondTouch) score += 25;
//     conditions.push({
//       name: "Failed First Retest",
//       met: isSecondTouch,
//       points: isSecondTouch ? 25 : 0,
//       detail: `Touch #${newTouchCount}${pullbackAfterFirstRef.current ? " (pullback ✓)" : " (no pullback)"}`,
//     });

//     const buyQty = live.totalBuyQty || 0;
//     const sellQty = live.totalSellQty || 0;
//     const sellDominant = sellQty > buyQty;
//     const ratio = sellQty > 0 ? (buyQty / sellQty).toFixed(2) : "∞";
//     if (sellDominant) score += 25;
//     conditions.push({
//       name: "Order Book Confirms",
//       met: sellDominant,
//       points: sellDominant ? 25 : 0,
//       detail: `B: ${buyQty.toLocaleString()} vs S: ${sellQty.toLocaleString()} (${ratio}x)`,
//     });

//     const currentVol = live.volume || 0;
//     const volDeclining =
//       morningAvgVolume && currentVol < morningAvgVolume * 0.8;
//     if (volDeclining) score += 25;
//     conditions.push({
//       name: "Volume Declining",
//       met: volDeclining,
//       points: volDeclining ? 25 : 0,
//       detail: `Now: ${currentVol?.toLocaleString()} vs Morn: ${morningAvgVolume?.toLocaleString() || "—"}`,
//     });

//     let signalType = "SKIP";
//     let signalMessage = "";

//     if (phase === "FIRST_WATCH") {
//       signalType = "FIRST_TOUCH";
//       signalMessage = `Touch #${newTouchCount} — observing, no action`;
//     } else if (score >= 100) {
//       signalType = "STRONG_SELL";
//       signalMessage = `4/4 conditions — STRONG SELL ₹${ltp.toFixed(2)}`;
//       setActiveSignal({ price: ltp, sl: stopLoss, target: target1 });
//     } else if (score >= 75) {
//       signalType = "SELL";
//       signalMessage = `3/4 conditions — SELL ₹${ltp.toFixed(2)}`;
//       setActiveSignal({ price: ltp, sl: stopLoss, target: target1 });
//     } else if (score >= 50) {
//       signalType = "WEAK_SELL";
//       signalMessage = `2/4 conditions — weak, half position`;
//     } else {
//       signalType = "SKIP";
//       signalMessage = `${score / 25}/4 conditions — skip`;
//     }

//     if (score >= 75) setStatus("SIGNAL");

//     addEntry({
//       type: signalType,
//       message: signalMessage,
//       price: ltp,
//       dayHigh: lockedHigh,
//       score,
//       touchNumber: newTouchCount,
//       buyQty,
//       sellQty,
//       ratio,
//       volume: currentVol,
//       morningVolume: morningAvgVolume,
//       conditions,
//     });
//   }, [live?.ltp, lockedHigh, touchCount, morningAvgVolume, stopLoss, target1]);

//   // SL / Target tracking
//   useEffect(() => {
//     if (!activeSignal || !live?.ltp) return;
//     const ltp = live.ltp;

//     if (ltp >= activeSignal.sl) {
//       addEntry({
//         type: "SL_HIT",
//         message: `SL hit ₹${ltp.toFixed(2)} — EXIT`,
//         price: ltp,
//         dayHigh: lockedHigh,
//         pnl: (((activeSignal.price - ltp) / activeSignal.price) * 100).toFixed(
//           2,
//         ),
//       });
//       setActiveSignal(null);
//       setStatus("SL_HIT");
//     }

//     if (activeSignal.target && ltp <= activeSignal.target) {
//       addEntry({
//         type: "TARGET_HIT",
//         message: `VWAP ₹${activeSignal.target.toFixed(2)} reached — PROFIT`,
//         price: ltp,
//         dayHigh: lockedHigh,
//         pnl: (((activeSignal.price - ltp) / activeSignal.price) * 100).toFixed(
//           2,
//         ),
//       });
//       setActiveSignal(null);
//       setStatus("TARGET_HIT");
//     }
//   }, [live?.ltp, activeSignal, lockedHigh]);

//   // Auto-exit 3:15 PM
//   useEffect(() => {
//     const checker = setInterval(() => {
//       const { totalMins } = getIST();
//       if (totalMins >= 915 && activeSignal && live?.ltp) {
//         addEntry({
//           type: "TIME_EXIT",
//           message: `3:15 PM exit ₹${live.ltp.toFixed(2)}`,
//           price: live.ltp,
//           dayHigh: lockedHigh,
//           pnl: (
//             ((activeSignal.price - live.ltp) / activeSignal.price) *
//             100
//           ).toFixed(2),
//         });
//         setActiveSignal(null);
//         setStatus("CLOSED");
//       }
//     }, 30000);
//     return () => clearInterval(checker);
//   }, [activeSignal, live?.ltp, lockedHigh]);

//   const { totalMins } = getIST();
//   const phase = getPhase(totalMins);
//   const currentBuyQty = live?.totalBuyQty || 0;
//   const currentSellQty = live?.totalSellQty || 0;
//   const currentRatio =
//     currentSellQty > 0 ? (currentBuyQty / currentSellQty).toFixed(2) : "—";
//   const pctFromHigh =
//     lockedHigh && live?.ltp
//       ? (((live.ltp - lockedHigh) / lockedHigh) * 100).toFixed(2)
//       : null;

//   const getTypeClass = (type) => {
//     const map = {
//       STRONG_SELL: "dhs-badge--strong-sell",
//       SELL: "dhs-badge--sell",
//       WEAK_SELL: "dhs-badge--weak",
//       SKIP: "dhs-badge--skip",
//       FIRST_TOUCH: "dhs-badge--first-touch",
//       LOCK: "dhs-badge--lock",
//       SL_HIT: "dhs-badge--sl",
//       TARGET_HIT: "dhs-badge--target",
//       TIME_EXIT: "dhs-badge--time-exit",
//     };
//     return map[type] || "dhs-badge--skip";
//   };

//   const getTypeBadge = (type) => {
//     const map = {
//       STRONG_SELL: "STRONG SELL",
//       SELL: "SELL",
//       WEAK_SELL: "WEAK",
//       SKIP: "SKIP",
//       FIRST_TOUCH: "1st TOUCH",
//       LOCK: "LOCKED",
//       SL_HIT: "SL HIT",
//       TARGET_HIT: "TARGET",
//       TIME_EXIT: "TIME EXIT",
//     };
//     return map[type] || type;
//   };

//   const statusMap = {
//     WAITING: { text: "⏳ Waiting for 10:30", cls: "dhs-status--waiting" },
//     BUILDING: {
//       text: `📈 Building: ₹${highTrackRef.current?.toFixed(2) || "—"}`,
//       cls: "dhs-status--building",
//     },
//     WATCHING: {
//       text: `👀 Locked ₹${lockedHigh?.toFixed(2)}`,
//       cls: "dhs-status--watching",
//     },
//     SIGNAL: { text: "🔴 SELL ACTIVE", cls: "dhs-status--signal" },
//     SL_HIT: { text: "❌ SL Hit", cls: "dhs-status--sl" },
//     TARGET_HIT: { text: "✅ Target Hit", cls: "dhs-status--target" },
//     CLOSED: { text: "⏹ Closed", cls: "dhs-status--closed" },
//   };
//   const st = statusMap[status] || statusMap.WAITING;

//   return (
//     <section className="dhs-wrapper">
//       {/* Header */}
//       <div className="dhs-header">
//         <h3 className="dhs-title">Day High Sell Strategy</h3>
//         <span className={`dhs-status ${st.cls}`}>{st.text}</span>
//       </div>

//       {/* Metrics */}
//       <div className="dhs-metrics">
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">Locked High</span>
//           <b className="dhs-metric__value">
//             {lockedHigh ? `₹${lockedHigh.toFixed(2)}` : "—"}
//           </b>
//         </div>
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">LTP</span>
//           <b className="dhs-metric__value">₹{live?.ltp?.toFixed(2) || "—"}</b>
//         </div>
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">From High</span>
//           <b
//             className={`dhs-metric__value ${pctFromHigh >= 0 ? "dhs-text--red" : "dhs-text--green"}`}
//           >
//             {pctFromHigh ? `${pctFromHigh}%` : "—"}
//           </b>
//         </div>
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">Touches</span>
//           <b className="dhs-metric__value">{touchCount}</b>
//         </div>
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">B/S Ratio</span>
//           <b
//             className={`dhs-metric__value ${currentBuyQty > currentSellQty ? "dhs-text--green" : "dhs-text--red"}`}
//           >
//             {currentRatio}x
//           </b>
//         </div>
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">Stop Loss</span>
//           <b className="dhs-metric__value dhs-text--red">
//             {stopLoss ? `₹${stopLoss}` : "—"}
//           </b>
//         </div>
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">Target</span>
//           <b className="dhs-metric__value dhs-text--green">
//             {target1 ? `₹${Number(target1).toFixed(2)}` : "—"}
//           </b>
//         </div>
//         <div className="dhs-metric">
//           <span className="dhs-metric__label">Phase</span>
//           <b className="dhs-metric__value">{phase}</b>
//         </div>
//       </div>

//       {/* Active Signal */}
//       {activeSignal && (
//         <div className="dhs-active-signal">
//           <div className="dhs-active-signal__row">
//             <span>
//               <b className="dhs-text--red">SELL ACTIVE</b> at ₹
//               {activeSignal.price?.toFixed(2)}
//             </span>
//             <span>
//               SL: <b className="dhs-text--red">₹{activeSignal.sl}</b>
//             </span>
//             <span>
//               Target:{" "}
//               <b className="dhs-text--green">
//                 ₹{activeSignal.target?.toFixed(2) || "—"}
//               </b>
//             </span>
//             <span>
//               P&L:{" "}
//               <b
//                 className={
//                   live?.ltp <= activeSignal.price
//                     ? "dhs-text--green"
//                     : "dhs-text--red"
//                 }
//               >
//                 {live?.ltp
//                   ? `${(((activeSignal.price - live.ltp) / activeSignal.price) * 100).toFixed(2)}%`
//                   : "—"}
//               </b>
//             </span>
//           </div>
//         </div>
//       )}

//       {/* Table */}
//       <div className="dhs-table-wrap">
//         <table className="dhs-table">
//           <thead>
//             <tr>
//               <th>Time</th>
//               <th>Signal</th>
//               <th>Score</th>
//               <th>LTP</th>
//               <th>Day High</th>
//               <th>Touch</th>
//               <th>Buy Qty</th>
//               <th>Sell Qty</th>
//               <th>Volume</th>
//               <th>P&L</th>
//               <th>Note</th>
//             </tr>
//           </thead>
//           <tbody>
//             {entries.length === 0 ? (
//               <tr>
//                 <td colSpan={11} className="dhs-table__empty">
//                   No signals yet — tracking starts at 10:30 AM
//                 </td>
//               </tr>
//             ) : (
//               entries.map((entry) => (
//                 <tr
//                   key={entry.id}
//                   className={
//                     entry.type === "STRONG_SELL" || entry.type === "SELL"
//                       ? "dhs-row--sell"
//                       : entry.type === "TARGET_HIT"
//                         ? "dhs-row--target"
//                         : entry.type === "SL_HIT"
//                           ? "dhs-row--sl"
//                           : ""
//                   }
//                 >
//                   <td>{entry.time}</td>
//                   <td>
//                     <span className={`dhs-badge ${getTypeClass(entry.type)}`}>
//                       {getTypeBadge(entry.type)}
//                     </span>
//                   </td>
//                   <td>
//                     {entry.score != null ? (
//                       <b
//                         className={
//                           entry.score >= 75
//                             ? "dhs-score--high"
//                             : entry.score >= 50
//                               ? "dhs-score--mid"
//                               : "dhs-score--low"
//                         }
//                       >
//                         {entry.score}/100
//                       </b>
//                     ) : (
//                       "—"
//                     )}
//                   </td>
//                   <td>₹{entry.price?.toFixed(2) || "—"}</td>
//                   <td>₹{(entry.dayHigh || lockedHigh)?.toFixed(2) || "—"}</td>
//                   <td>{entry.touchNumber || "—"}</td>
//                   <td className="dhs-text--green">
//                     {entry.buyQty?.toLocaleString() || "—"}
//                   </td>
//                   <td className="dhs-text--red">
//                     {entry.sellQty?.toLocaleString() || "—"}
//                   </td>
//                   <td>{entry.volume?.toLocaleString() || "—"}</td>
//                   <td
//                     className={
//                       Number(entry.pnl) > 0
//                         ? "dhs-pnl--profit"
//                         : Number(entry.pnl) < 0
//                           ? "dhs-pnl--loss"
//                           : ""
//                     }
//                   >
//                     {entry.pnl ? `${entry.pnl}%` : "—"}
//                   </td>
//                   <td className="dhs-table__note">{entry.message}</td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Condition Breakdown */}
//       {entries[0]?.conditions && (
//         <div className="dhs-conditions">
//           <b className="dhs-conditions__title">Last Signal Breakdown:</b>
//           <div className="dhs-conditions__grid">
//             {entries[0].conditions.map((c) => (
//               <div key={c.name} className="dhs-condition">
//                 <span
//                   className={
//                     c.met
//                       ? "dhs-condition__icon--pass"
//                       : "dhs-condition__icon--fail"
//                   }
//                 >
//                   {c.met ? "✓" : "✗"}
//                 </span>
//                 <span className="dhs-condition__text">
//                   <b>{c.name}</b>
//                   {c.detail && (
//                     <span className="dhs-condition__detail"> — {c.detail}</span>
//                   )}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Rules */}
//       <div className="dhs-rules">
//         <b className="dhs-rules__title">Strategy Rules:</b>
//         <p className="dhs-rules__text">
//           10:30–12:00 Build high + avg volume → Lock at 12:00 → 12:00–12:30
//           Watch 1st touch (no sell) → 12:30–2:30 SELL on 2nd touch if score ≥ 75
//           → SL = High + 0.3% | Target = VWAP | Auto-exit 3:15 PM
//         </p>
//       </div>
//     </section>
//   );
// };
// DayHighPage.jsx

import { useParams, useNavigate } from "react-router-dom";
import useLivePrices from "../../hooks/useLivePrices";
import { useStockSnapshot } from "../../context/StockSnapshotContext";
import { FiArrowLeft } from "react-icons/fi";
import "./DayHighStrategy.css";

const DayHighStrategy = () => {
  const { symbol, securityId } = useParams();
  const navigate = useNavigate();

  // Fetch stock data
  const {
    stockDetail,
    stockDetailLoading,
    stockDetailError,
    getStockDetailSnapshot,
  } = useStockSnapshot();

  // Live prices
  const { prices: livePrices, subscribeSymbols } = useLivePrices();

  // Fetch on mount
  useEffect(() => {
    if (!symbol) return;
    getStockDetailSnapshot(symbol, securityId);
    subscribeSymbols([symbol]);
  }, [symbol]);
  // Late join: if page opened after 12:00, use quote high as locked high

  // Derive data from snapshot
  const live = livePrices[symbol];
  const quote = stockDetail?.marketSnapshot?.quote?.data;
  const ohlc = quote?.ohlc;
  const quoteHigh = live?.high || ohlc?.high;
  const vwap = stockDetail?.marketSnapshot?.intraday?.vwap;
  const companyName = stockDetail?.stockData?.company;
  const lastPrice = live?.ltp || quote?.last_price;
  const close = ohlc?.close;
  const percentChange =
    close && lastPrice
      ? (((lastPrice - close) / close) * 100).toFixed(2)
      : "0.00";
  const isPositive = Number(percentChange) >= 0;

  // ─── Strategy State ───
  const [entries, setEntries] = useState([]);
  const [lockedHigh, setLockedHigh] = useState(null);
  const [morningAvgVolume, setMorningAvgVolume] = useState(null);
  const [touchCount, setTouchCount] = useState(0);
  const [status, setStatus] = useState("WAITING");
  const [stopLoss, setStopLoss] = useState(null);
  const [target1, setTarget1] = useState(null);
  const [activeSignal, setActiveSignal] = useState(null);

  const highTrackRef = useRef(null);
  const volumeSamplesRef = useRef([]);
  const signalFiredRef = useRef(new Set());
  const pullbackAfterFirstRef = useRef(false);

  const getIST = useCallback(() => {
    const now = new Date();
    const ist = new Date(
      now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }),
    );
    return {
      totalMins: ist.getHours() * 60 + ist.getMinutes(),
      timeStr: ist.toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      }),
    };
  }, []);

  const getPhase = useCallback((totalMins) => {
    if (totalMins < 630) return "PRE_MARKET";
    if (totalMins >= 630 && totalMins < 720) return "BUILDING";
    if (totalMins === 720) return "LOCK";
    if (totalMins > 720 && totalMins < 750) return "FIRST_WATCH";
    if (totalMins >= 750 && totalMins < 870) return "SELL_ZONE";
    if (totalMins >= 870 && totalMins < 930) return "AVOID";
    return "CLOSED";
  }, []);

  const addEntry = useCallback(
    (entry) => {
      const { timeStr } = getIST();
      setEntries((prev) =>
        [{ id: Date.now(), time: timeStr, ...entry }, ...prev].slice(0, 100),
      );
    },
    [getIST],
  );

  // Phase 1: Build High + Track Volume
  useEffect(() => {
    if (!live?.ltp) return;
    const { totalMins } = getIST();
    const phase = getPhase(totalMins);

    if (phase === "BUILDING") {
      const currentHigh = live.high || live.ltp;
      if (!highTrackRef.current || currentHigh > highTrackRef.current) {
        highTrackRef.current = currentHigh;
      }
      if (live.volume) volumeSamplesRef.current.push(live.volume);
      setStatus("BUILDING");
    }

    if (phase === "LOCK" && !lockedHigh) {
      const finalHigh = highTrackRef.current || live.high || quoteHigh;
      const samples = volumeSamplesRef.current;
      const avgVol =
        samples.length > 0
          ? Math.round(samples.reduce((a, b) => a + b, 0) / samples.length)
          : null;
      const sl = Number((finalHigh * 1.003).toFixed(2));

      setLockedHigh(finalHigh);
      setMorningAvgVolume(avgVol);
      setStopLoss(sl);
      setTarget1(vwap || null);
      setStatus("WATCHING");

      addEntry({
        type: "LOCK",
        message: `Day High locked. Morning avg vol: ${avgVol?.toLocaleString() || "—"}`,
        price: live.ltp,
        dayHigh: finalHigh,
        score: null,
      });
    }
  }, [live?.ltp, live?.high, live?.volume, lockedHigh, quoteHigh, vwap]);

  // Phase 2: Monitor Retests
  useEffect(() => {
    if (!lockedHigh || !live?.ltp) return;
    const { totalMins } = getIST();
    const phase = getPhase(totalMins);

    if (phase !== "FIRST_WATCH" && phase !== "SELL_ZONE") return;

    const ltp = live.ltp;
    const threshold = lockedHigh * 0.998;

    if (touchCount === 1 && ltp < lockedHigh * 0.995) {
      pullbackAfterFirstRef.current = true;
    }

    if (ltp < threshold) return;

    const blockKey = `${Math.floor(totalMins / 3)}`;
    if (signalFiredRef.current.has(blockKey)) return;
    signalFiredRef.current.add(blockKey);

    const newTouchCount = touchCount + 1;
    setTouchCount(newTouchCount);

    let score = 0;
    const conditions = [];

    score += 25;
    conditions.push({ name: "Day High Locked", met: true, points: 25 });

    const isSecondTouch = newTouchCount >= 2 && pullbackAfterFirstRef.current;
    if (isSecondTouch) score += 25;
    conditions.push({
      name: "Failed First Retest",
      met: isSecondTouch,
      points: isSecondTouch ? 25 : 0,
      detail: `Touch #${newTouchCount}${pullbackAfterFirstRef.current ? " (pullback ✓)" : " (no pullback)"}`,
    });

    const buyQty = live.totalBuyQty || 0;
    const sellQty = live.totalSellQty || 0;
    const sellDominant = sellQty > buyQty;
    const ratio = sellQty > 0 ? (buyQty / sellQty).toFixed(2) : "∞";
    if (sellDominant) score += 25;
    conditions.push({
      name: "Order Book Confirms",
      met: sellDominant,
      points: sellDominant ? 25 : 0,
      detail: `B: ${buyQty.toLocaleString()} vs S: ${sellQty.toLocaleString()} (${ratio}x)`,
    });

    const currentVol = live.volume || 0;
    const volDeclining =
      morningAvgVolume && currentVol < morningAvgVolume * 0.8;
    if (volDeclining) score += 25;
    conditions.push({
      name: "Volume Declining",
      met: volDeclining,
      points: volDeclining ? 25 : 0,
      detail: `Now: ${currentVol?.toLocaleString()} vs Morn: ${morningAvgVolume?.toLocaleString() || "—"}`,
    });

    let signalType = "SKIP";
    let signalMessage = "";

    if (phase === "FIRST_WATCH") {
      signalType = "FIRST_TOUCH";
      signalMessage = `Touch #${newTouchCount} — observing, no action`;
    } else if (score >= 100) {
      signalType = "STRONG_SELL";
      signalMessage = `4/4 conditions — STRONG SELL ₹${ltp.toFixed(2)}`;
      setActiveSignal({ price: ltp, sl: stopLoss, target: target1 });
    } else if (score >= 75) {
      signalType = "SELL";
      signalMessage = `3/4 conditions — SELL ₹${ltp.toFixed(2)}`;
      setActiveSignal({ price: ltp, sl: stopLoss, target: target1 });
    } else if (score >= 50) {
      signalType = "WEAK_SELL";
      signalMessage = `2/4 conditions — weak, half position`;
    } else {
      signalType = "SKIP";
      signalMessage = `${score / 25}/4 conditions — skip`;
    }

    if (score >= 75) setStatus("SIGNAL");

    addEntry({
      type: signalType,
      message: signalMessage,
      price: ltp,
      dayHigh: lockedHigh,
      score,
      touchNumber: newTouchCount,
      buyQty,
      sellQty,
      ratio,
      volume: currentVol,
      morningVolume: morningAvgVolume,
      conditions,
    });
  }, [live?.ltp, lockedHigh, touchCount, morningAvgVolume, stopLoss, target1]);

  // SL / Target tracking
  useEffect(() => {
    if (!activeSignal || !live?.ltp) return;
    const ltp = live.ltp;

    if (ltp >= activeSignal.sl) {
      addEntry({
        type: "SL_HIT",
        message: `SL hit ₹${ltp.toFixed(2)} — EXIT`,
        price: ltp,
        dayHigh: lockedHigh,
        pnl: (((activeSignal.price - ltp) / activeSignal.price) * 100).toFixed(
          2,
        ),
      });
      setActiveSignal(null);
      setStatus("SL_HIT");
    }

    if (activeSignal.target && ltp <= activeSignal.target) {
      addEntry({
        type: "TARGET_HIT",
        message: `VWAP ₹${activeSignal.target.toFixed(2)} reached — PROFIT`,
        price: ltp,
        dayHigh: lockedHigh,
        pnl: (((activeSignal.price - ltp) / activeSignal.price) * 100).toFixed(
          2,
        ),
      });
      setActiveSignal(null);
      setStatus("TARGET_HIT");
    }
  }, [live?.ltp, activeSignal, lockedHigh]);

  // Auto-exit 3:15 PM
  useEffect(() => {
    const checker = setInterval(() => {
      const { totalMins } = getIST();
      if (totalMins >= 915 && activeSignal && live?.ltp) {
        addEntry({
          type: "TIME_EXIT",
          message: `3:15 PM exit ₹${live.ltp.toFixed(2)}`,
          price: live.ltp,
          dayHigh: lockedHigh,
          pnl: (
            ((activeSignal.price - live.ltp) / activeSignal.price) *
            100
          ).toFixed(2),
        });
        setActiveSignal(null);
        setStatus("CLOSED");
      }
    }, 30000);
    return () => clearInterval(checker);
  }, [activeSignal, live?.ltp, lockedHigh]);
  useEffect(() => {
    if (lockedHigh) return; // already locked, skip
    if (!live?.ltp && !quoteHigh) return;

    const { totalMins } = getIST();
    const phase = getPhase(totalMins);

    // If we're past the LOCK phase but never locked, reconstruct from quote
    if (phase === "FIRST_WATCH" || phase === "SELL_ZONE" || phase === "AVOID") {
      const fallbackHigh = live?.high || quoteHigh || ohlc?.high;
      if (!fallbackHigh) return;

      const sl = Number((fallbackHigh * 1.003).toFixed(2));

      setLockedHigh(fallbackHigh);
      setStopLoss(sl);
      setTarget1(vwap || null);
      setStatus("WATCHING");

      addEntry({
        type: "LOCK",
        message: `Day High reconstructed from quote data (late join)`,
        price: live?.ltp || lastPrice,
        dayHigh: fallbackHigh,
        score: null,
      });
    }
  }, [live?.ltp, quoteHigh, lockedHigh, vwap]);

  // ─── Helpers ───
  const { totalMins } = getIST();
  const phase = getPhase(totalMins);
  const currentBuyQty = live?.totalBuyQty || 0;
  const currentSellQty = live?.totalSellQty || 0;
  const currentRatio =
    currentSellQty > 0 ? (currentBuyQty / currentSellQty).toFixed(2) : "—";
  const pctFromHigh =
    lockedHigh && live?.ltp
      ? (((live.ltp - lockedHigh) / lockedHigh) * 100).toFixed(2)
      : null;

  const getTypeClass = (type) => {
    const map = {
      STRONG_SELL: "dhs-badge--strong-sell",
      SELL: "dhs-badge--sell",
      WEAK_SELL: "dhs-badge--weak",
      SKIP: "dhs-badge--skip",
      FIRST_TOUCH: "dhs-badge--first-touch",
      LOCK: "dhs-badge--lock",
      SL_HIT: "dhs-badge--sl",
      TARGET_HIT: "dhs-badge--target",
      TIME_EXIT: "dhs-badge--time-exit",
    };
    return map[type] || "dhs-badge--skip";
  };

  const getTypeBadge = (type) => {
    const map = {
      STRONG_SELL: "STRONG SELL",
      SELL: "SELL",
      WEAK_SELL: "WEAK",
      SKIP: "SKIP",
      FIRST_TOUCH: "1st TOUCH",
      LOCK: "LOCKED",
      SL_HIT: "SL HIT",
      TARGET_HIT: "TARGET",
      TIME_EXIT: "TIME EXIT",
    };
    return map[type] || type;
  };

  const statusMap = {
    WAITING: { text: "⏳ Waiting for 10:30", cls: "dhs-status--waiting" },
    BUILDING: {
      text: `📈 Building: ₹${highTrackRef.current?.toFixed(2) || "—"}`,
      cls: "dhs-status--building",
    },
    WATCHING: {
      text: `👀 Locked ₹${lockedHigh?.toFixed(2)}`,
      cls: "dhs-status--watching",
    },
    SIGNAL: { text: "🔴 SELL ACTIVE", cls: "dhs-status--signal" },
    SL_HIT: { text: "❌ SL Hit", cls: "dhs-status--sl" },
    TARGET_HIT: { text: "✅ Target Hit", cls: "dhs-status--target" },
    CLOSED: { text: "⏹ Closed", cls: "dhs-status--closed" },
  };
  const st = statusMap[status] || statusMap.WAITING;

  // ─── Loading / Error ───
  if (stockDetailLoading) {
    return (
      <div className="dhs-page">
        <p className="dhs-loading">Loading {symbol} data...</p>
      </div>
    );
  }

  if (stockDetailError) {
    return (
      <div className="dhs-page">
        <p className="dhs-error">{stockDetailError}</p>
      </div>
    );
  }

  return (
    <div className="dhs-page">
      {/* ─── Stock Header ─── */}
      <div className="dhs-stock-header">
        <button className="dhs-back-btn" onClick={() => navigate(-1)}>
          <FiArrowLeft size={18} />
          Back
        </button>

        <div className="dhs-stock-info">
          <div className="dhs-stock-name">
            <h2>{symbol}</h2>
            {companyName && <span>{companyName}</span>}
          </div>
          <div className="dhs-stock-price">
            <h2>₹{lastPrice || "—"}</h2>
            <span className={isPositive ? "dhs-text--green" : "dhs-text--red"}>
              {isPositive ? "▲" : "▼"} {percentChange}%
            </span>
          </div>
        </div>

        <div className="dhs-stock-ohlc">
          <div>
            <span>Open</span>
            <b>₹{ohlc?.open || "—"}</b>
          </div>
          <div>
            <span>High</span>
            <b>₹{ohlc?.high || "—"}</b>
          </div>
          <div>
            <span>Low</span>
            <b>₹{ohlc?.low || "—"}</b>
          </div>
          <div>
            <span>Prev Close</span>
            <b>₹{close || "—"}</b>
          </div>
          <div>
            <span>VWAP</span>
            <b>₹{vwap ? Number(vwap).toFixed(2) : "—"}</b>
          </div>
        </div>
      </div>

      {/* ─── Strategy Section ─── */}
      <section className="dhs-wrapper">
        <div className="dhs-header">
          <h3 className="dhs-title">Day High Sell Strategy</h3>
          <span className={`dhs-status ${st.cls}`}>{st.text}</span>
        </div>

        <div className="dhs-metrics">
          <div className="dhs-metric">
            <span className="dhs-metric__label">Locked High</span>
            <b className="dhs-metric__value">
              {lockedHigh ? `₹${lockedHigh.toFixed(2)}` : "—"}
            </b>
          </div>
          <div className="dhs-metric">
            <span className="dhs-metric__label">LTP</span>
            <b className="dhs-metric__value">₹{live?.ltp?.toFixed(2) || "—"}</b>
          </div>
          <div className="dhs-metric">
            <span className="dhs-metric__label">From High</span>
            <b
              className={`dhs-metric__value ${pctFromHigh >= 0 ? "dhs-text--red" : "dhs-text--green"}`}
            >
              {pctFromHigh ? `${pctFromHigh}%` : "—"}
            </b>
          </div>
          <div className="dhs-metric">
            <span className="dhs-metric__label">Touches</span>
            <b className="dhs-metric__value">{touchCount}</b>
          </div>
          <div className="dhs-metric">
            <span className="dhs-metric__label">B/S Ratio</span>
            <b
              className={`dhs-metric__value ${currentBuyQty > currentSellQty ? "dhs-text--green" : "dhs-text--red"}`}
            >
              {currentRatio}x
            </b>
          </div>
          <div className="dhs-metric">
            <span className="dhs-metric__label">Stop Loss</span>
            <b className="dhs-metric__value dhs-text--red">
              {stopLoss ? `₹${stopLoss}` : "—"}
            </b>
          </div>
          <div className="dhs-metric">
            <span className="dhs-metric__label">Target</span>
            <b className="dhs-metric__value dhs-text--green">
              {target1 ? `₹${Number(target1).toFixed(2)}` : "—"}
            </b>
          </div>
          <div className="dhs-metric">
            <span className="dhs-metric__label">Phase</span>
            <b className="dhs-metric__value">{phase}</b>
          </div>
        </div>

        {activeSignal && (
          <div className="dhs-active-signal">
            <div className="dhs-active-signal__row">
              <span>
                <b className="dhs-text--red">SELL ACTIVE</b> at ₹
                {activeSignal.price?.toFixed(2)}
              </span>
              <span>
                SL: <b className="dhs-text--red">₹{activeSignal.sl}</b>
              </span>
              <span>
                Target:{" "}
                <b className="dhs-text--green">
                  ₹{activeSignal.target?.toFixed(2) || "—"}
                </b>
              </span>
              <span>
                P&L:{" "}
                <b
                  className={
                    live?.ltp <= activeSignal.price
                      ? "dhs-text--green"
                      : "dhs-text--red"
                  }
                >
                  {live?.ltp
                    ? `${(((activeSignal.price - live.ltp) / activeSignal.price) * 100).toFixed(2)}%`
                    : "—"}
                </b>
              </span>
            </div>
          </div>
        )}

        <div className="dhs-table-wrap">
          <table className="dhs-table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Signal</th>
                <th>Score</th>
                <th>LTP</th>
                <th>Day High</th>
                <th>Touch</th>
                <th>Buy Qty</th>
                <th>Sell Qty</th>
                <th>Volume</th>
                <th>P&L</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {entries.length === 0 ? (
                <tr>
                  <td colSpan={11} className="dhs-table__empty">
                    No signals yet — tracking starts at 10:30 AM
                  </td>
                </tr>
              ) : (
                entries.map((entry) => (
                  <tr
                    key={entry.id}
                    className={
                      entry.type === "STRONG_SELL" || entry.type === "SELL"
                        ? "dhs-row--sell"
                        : entry.type === "TARGET_HIT"
                          ? "dhs-row--target"
                          : entry.type === "SL_HIT"
                            ? "dhs-row--sl"
                            : ""
                    }
                  >
                    <td>{entry.time}</td>
                    <td>
                      <span className={`dhs-badge ${getTypeClass(entry.type)}`}>
                        {getTypeBadge(entry.type)}
                      </span>
                    </td>
                    <td>
                      {entry.score != null ? (
                        <b
                          className={
                            entry.score >= 75
                              ? "dhs-score--high"
                              : entry.score >= 50
                                ? "dhs-score--mid"
                                : "dhs-score--low"
                          }
                        >
                          {entry.score}/100
                        </b>
                      ) : (
                        "—"
                      )}
                    </td>
                    <td>₹{entry.price?.toFixed(2) || "—"}</td>
                    <td>₹{(entry.dayHigh || lockedHigh)?.toFixed(2) || "—"}</td>
                    <td>{entry.touchNumber || "—"}</td>
                    <td className="dhs-text--green">
                      {entry.buyQty?.toLocaleString() || "—"}
                    </td>
                    <td className="dhs-text--red">
                      {entry.sellQty?.toLocaleString() || "—"}
                    </td>
                    <td>{entry.volume?.toLocaleString() || "—"}</td>
                    <td
                      className={
                        Number(entry.pnl) > 0
                          ? "dhs-pnl--profit"
                          : Number(entry.pnl) < 0
                            ? "dhs-pnl--loss"
                            : ""
                      }
                    >
                      {entry.pnl ? `${entry.pnl}%` : "—"}
                    </td>
                    <td className="dhs-table__note">{entry.message}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {entries[0]?.conditions && (
          <div className="dhs-conditions">
            <b className="dhs-conditions__title">Last Signal Breakdown:</b>
            <div className="dhs-conditions__grid">
              {entries[0].conditions.map((c) => (
                <div key={c.name} className="dhs-condition">
                  <span
                    className={
                      c.met
                        ? "dhs-condition__icon--pass"
                        : "dhs-condition__icon--fail"
                    }
                  >
                    {c.met ? "✓" : "✗"}
                  </span>
                  <span className="dhs-condition__text">
                    <b>{c.name}</b>
                    {c.detail && (
                      <span className="dhs-condition__detail">
                        {" "}
                        — {c.detail}
                      </span>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="dhs-rules">
          <b className="dhs-rules__title">Strategy Rules:</b>
          <p className="dhs-rules__text">
            10:30–12:00 Build high + avg volume → Lock at 12:00 → 12:00–12:30
            Watch 1st touch (no sell) → 12:30–2:30 SELL on 2nd touch if score ≥
            75 → SL = High + 0.3% | Target = VWAP | Auto-exit 3:15 PM
          </p>
        </div>
      </section>
    </div>
  );
};

// export default DayHighStrategy;

export default DayHighStrategy;
